import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CategoryIcon from "@mui/icons-material/Category";
import { designColors, designShell } from "services/constants/designTokens";

// Shared visual tokens + lookups for the redesigned Leave screen, kept in one
// place so the balance cards, summary panel and history table all read as one
// system and a palette tweak is a single edit.
export const leavePalette = {
  pageBg: designColors.pageBg,
  card: designColors.white,
  border: designColors.slate200,
  text: designColors.slate900,
  subText: designColors.slate600,
  green: "#12B76A",
  blue: "#2E90FA",
  purple: "#7A5AF8",
  amber: "#F79009",
  red: "#F04438",
  gray: "#98A2B3",
};

export const cardSx = {
  ...designShell.sectionCard,
};

// Per-leave-type icon + accent. Matched on the leave_type name the API returns
// (leavetypefilter / leave_requests both use the same names). Unknown types
// fall back to a neutral icon/colour so a newly configured type still renders.
const TYPE_MAP = {
  "annual leave": { icon: EventAvailableIcon, color: leavePalette.green },
  "casual leave": { icon: BeachAccessIcon, color: leavePalette.blue },
  "sick leave": { icon: FavoriteBorderIcon, color: leavePalette.purple },
  "comp off": { icon: AccessTimeIcon, color: leavePalette.amber },
  "comp-off": { icon: AccessTimeIcon, color: leavePalette.amber },
};

export const typeMeta = (leaveType) => {
  const key = (leaveType || "").trim().toLowerCase();
  return TYPE_MAP[key] || { icon: CategoryIcon, color: leavePalette.gray };
};

// Status pill colour. Falls back to the row's own color_code when the status
// name isn't one of the known four, so custom workflow statuses still show.
export const statusMeta = (status, colorCode) => {
  const key = (status || "").trim().toLowerCase();
  const map = {
    approved: leavePalette.green,
    pending: leavePalette.amber,
    rejected: leavePalette.red,
    cancelled: leavePalette.gray,
    canceled: leavePalette.gray,
  };
  return map[key] || colorCode || leavePalette.blue;
};

// "Applied On" isn't a single guaranteed field across leave rows, so accept the
// first present of the known candidates rather than assuming one.
export const appliedOn = (row) =>
  row?.applied_date ||
  row?.created_date ||
  row?.requested_date ||
  row?.created_at ||
  "";
